export const DISABLE_TABLE_SCROLL = "DISABLE_TABLE_SCROLL";
export const ENABLE_TABLE_SCROLL = "ENABLE_TABLE_SCROLL";
